/**
 * Calculate dynamic width based on placeholder text length
 * @param placeholder - The placeholder text
 * @param hasIcon - Whether the input has an icon
 * @returns CSS width class string
 */
export const calculateInputWidth = (placeholder?: string, hasIcon?: boolean): string => {
  if (!placeholder) return 'w-[180px]'; // Default width when no placeholder

  // Base padding: 24px (px-3 = 12px each side) or 40px (pl-10 pr-3) with icon
  const basePadding = hasIcon ? 40 : 24;

  // Approximate character width in pixels (roughly 8px per character for text-sm)
  const charWidth = 8;
  const textWidth = placeholder.length * charWidth;

  // Calculate total width needed
  const totalWidth = textWidth + basePadding;

  // Ensure minimum width of 120px and maximum of 400px
  const clampedWidth = Math.max(120, Math.min(400, totalWidth));

  return `w-[${clampedWidth}px]`;
};
